<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M23.2357 15.9763C23.2357 11.9813 19.9893 8.72989 16 8.72989C12.0107 8.72989 8.76429 11.9811 8.76429 15.9763C8.76429 19.9716 12.0107 23.2227 16 23.2227C19.9893 23.2227 23.2357 19.9716 23.2357 15.9763Z"
    />
    <path
      d="M17.3913 5.34123V1.39336C17.3913 0.604162 16.788 0 16 0C15.212 0 14.6087 0.604162 14.6087 1.39336V5.34123C14.6087 6.13043 15.212 6.73459 16 6.73459C16.788 6.73459 17.3913 6.08329 17.3913 5.34123Z"
    />
    <path
      d="M17.3913 30.6066V26.6588C17.3913 25.8696 16.788 25.2654 16 25.2654C15.212 25.2654 14.6087 25.8696 14.6087 26.6588V30.6066C14.6087 31.3958 15.212 32 16 32C16.788 32 17.3913 31.3505 17.3913 30.6066Z"
    />
    <path
      d="M0 15.9763C0 16.7655 0.60327 17.3697 1.3913 17.3697H5.33333C6.12137 17.3697 6.72464 16.7655 6.72464 15.9763C6.72464 15.1871 6.12137 14.5829 5.33333 14.5829H1.3913C0.648533 14.5829 0 15.1871 0 15.9763Z"
    />
    <path
      d="M32 15.9763C32 15.1871 31.3967 14.5829 30.6087 14.5829H26.6667C25.8786 14.5829 25.2754 15.1871 25.2754 15.9763C25.2754 16.7655 25.8786 17.3697 26.6667 17.3697H30.6087C31.3515 17.3697 32 16.7655 32 15.9763Z"
    />
    <path
      d="M24.3005 9.19435L27.036 6.3151C27.5469 5.75812 27.5469 4.87455 26.9889 4.36476C26.4328 3.85312 25.5505 3.85312 25.0415 4.41193L22.306 7.29118C21.7951 7.84815 21.7951 8.73173 22.3531 9.24152C22.632 9.47374 22.9563 9.61344 23.3277 9.61344C23.652 9.61344 24.0233 9.47374 24.3005 9.19435Z"
    />
    <path
      d="M9.64684 22.7109C9.09069 22.1993 8.20842 22.1993 7.69939 22.7581L4.9639 25.6373C4.45301 26.1943 4.45301 27.0779 5.011 27.5877C5.28998 27.8199 5.61427 27.9596 5.98565 27.9596C6.35704 27.9596 6.72842 27.8199 7.00557 27.5423L9.74106 24.6631C10.2501 24.1043 10.2501 23.2225 9.64684 22.7109Z"
    />
    <path
      d="M9.22806 7.6635L6.35307 4.92396C5.79692 4.41232 4.91464 4.41232 4.40561 4.97113C3.89472 5.52811 3.89472 6.41169 4.45271 6.92147L7.3277 9.66101C7.60669 9.89324 7.93097 10.0329 8.30236 10.0329C8.67373 10.0329 9.04513 9.89324 9.32228 9.61565C9.78604 9.05687 9.78603 8.17329 9.22806 7.6635Z"
    />
    <path
      d="M26.6194 27.4028C26.9907 27.4028 27.3621 27.2631 27.6393 26.9855C28.1502 26.4286 28.1502 25.545 27.5922 25.0352L24.7172 22.2957C24.161 21.784 23.2788 21.784 22.7697 22.3428C22.2588 22.8998 22.2588 23.7834 22.8168 24.2932L25.6918 27.0327C25.9237 27.2631 26.2951 27.4028 26.6194 27.4028Z"
    />
  </svg>
</template>
